import classNames from 'classnames';
import { ComponentType } from '@/types/cml-api';
import { AppNextLink } from '@/features/app-next-link';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { Webengage } from '@/features/webengage';
import SafeHtml from '@/components/safe-html';
import { useDataLayerPush } from '@/app/_utils/use-datalayer-push';
import { useGetPLPBanner } from '../_utils/use-get-plp-banner';
import { PLPBannerProps, PLPPages, PurePLPBasicMetasProps } from '../types';
const PLPBanner = ({
  page,
  searchParams,
  basicMetas
}: PLPBannerProps) => {
  const {
    isMobile
  } = useMobileDetect();
  const {
    data,
    isLoading
  } = useGetPLPBanner({
    searchParams
  });
  const pushToDataLayer = useDataLayerPush();
  const isTagPage = page === PLPPages.Tags;
  const tagsBasicMeta = basicMetas as PurePLPBasicMetasProps;
  const hasData = data?.desktopImageUrl || tagsBasicMeta?.description;
  if (isLoading) return <div className='mb-4 lg:mx-14'>
                <div className='h-16 w-full animate-pulse rounded bg-gray-100 lg:h-24' />
            </div>;
  const handleClick = () => {
    pushToDataLayer({
      event: 'cta_click',
      elementType: ComponentType.PlpBanner,
      elementName: ComponentType.PlpBanner,
      elementIndex: 0,
      destinationUrl: data?.link || '',
      ImageUrl: isMobile ? data?.mobileImageUrl : data?.desktopImageUrl,
      itemID: data?.id?.toString() || ''
    });
    Webengage.trackCtaAction({
      banner_type: ComponentType.PlpBanner,
      banner_name: ComponentType.PlpBanner,
      banner_index: '0',
      url_destination: data?.link || '',
      item_id: data?.id?.toString() || '',
      component_id: '',
      image_url: (isMobile ? data?.mobileImageUrl : data?.desktopImageUrl) ?? ''
    });
  };
  return <div className={classNames(
  // eslint-disable-next-line no-nested-ternary
  isTagPage ? hasData ? 'mb-6 rounded border border-border-pink lg:mx-0' : 'mb-6 lg:mx-0' : 'mb-4 lg:mx-14')} data-sentry-component="PLPBanner" data-sentry-source-file="plp-banner.tsx">
            {!data || !data?.desktopImageUrl || !data?.mobileImageUrl ? '' : <AppNextLink href={data.link || ''} prefetch={false} onClick={handleClick} className={`${isTagPage ? 'block' : ''} ${tagsBasicMeta?.description ? 'mb-4' : 'mb-0'} h-auto w-full`}>
                    <picture>
                        <source media='(min-width: 1024px)' srcSet={data?.desktopImageUrl} />
                        <img src={data?.mobileImageUrl} alt={data.name || 'بنر لیست محصولات'} className={`h-full w-full ${isTagPage ? '' : 'rounded'} object-contain`} />
                    </picture>
                </AppNextLink>}
            {isTagPage && tagsBasicMeta?.description && <div className='p-3'>
                    <SafeHtml content={tagsBasicMeta.description} className='text-xs lg:text-sm' />
                </div>}
        </div>;
};
export default PLPBanner;